// src/components/PrivateRoute.tsx
import React from 'react';
import { Route, Redirect, RouteProps } from 'react-router-dom';
import { useAuth } from '@context/auth';

// O PrivateLayout será usado aqui
import PrivateLayout from './PrivateLayout';

// Estendemos as props de uma Rota normal
interface PrivateRouteProps extends RouteProps {
  component: React.ComponentType<any>;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ component: Component, ...rest }) => {
  const { user } = useAuth();

  return (
    <Route
      {...rest}
      render={props =>
        user ? (
          // Se o usuário estiver logado, renderiza o PrivateLayout
          // e dentro dele o componente da rota solicitada.
          <PrivateLayout>
            <Component {...props} />
          </PrivateLayout>
        ) : (
          // Se não estiver logado, redireciona para a tela de login.
          <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
        )
      }
    />
  );
};

export default PrivateRoute;
